import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const GenericEmbedCard = ({ image, onClick, label, className, description }) => (
  <div className={`ui centered card link ${className}`} onClick={onClick}>
    <div className="image" style={{ background: '#fff' }}>
      <img
        className="ui centered image"
        src={image}
        alt={`${label} Logo`}
        style={{ width: '6.25rem', marginTop: '1.25rem', marginBottom: '1.25rem' }}
      />
    </div>
    <div className="content">
      <div className="header">{label}</div>
      <div className="meta">{description}</div>
    </div>
  </div>
)

GenericEmbedCard.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  description: PropTypes.string,
}

const StyledGenericEmbedCard = styled(GenericEmbedCard)`
  cursor: 'pointer';
  box-shadow: ${(props) =>
    props.selectedSurvey === props.type ? '0px 0px 0px 4px #4EC677 !important' : null};
`

export default StyledGenericEmbedCard



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/ChooseHelpdeskModal/GenericEmbedCard.js